<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> بدهکاری/بستانکاری رانندگان {{ bEmdadRan ? 'امدادران' : 'تاکسی لون' }} </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-md-0 gy-3" [formGroup]="mdl_Search">

        <!-- نام راننده -->
        
        <div class="position-relative col-12 col-md-3 p-2">

            <label class="text-muted"> نام راننده </label>

            <input class="form-control p-2 text-center" formControlName="strFullName">

        </div>

        <!-- موبایل راننده -->
        
        <div class="position-relative col-12 col-md-3 p-2">

            <label class="text-muted"> موبایل راننده </label>

            <input class="form-control p-2 text-center"

                maxlength="11"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="strMobile">

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent py-2">

            <button class="btn btn-primary w-100" (click)="search_Driver()"> 

                &nbsp; جستجو &nbsp;
                
            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent py-2">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')"> 

                خروجی اکسل
                
            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

        <div class="section border border-2 mt-2" style="height:calc(100vh - 250px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="">
        
                        <th class="text-center"> # </th>
    
                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> {{ bEmdadRan ? 'کد خدمت' : 'کد سفر' }} </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> نام راننده </th>

                        <th class="text-center"> موبایل راننده </th>

                        <th class="text-center"> بدهکاری </th>

                        <th class="text-center"> بستانکاری </th>

                        <th class="text-center"> شرح </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Debit_Credit;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="">  

                            <i class="fa fa-plus-square fa-lg pointer" title="افزودن بدهکاری/بستانکاری" (click)="add_Request(item)"></i>

                            <i class="fa fa-pencil-square fa-lg mx-2 pointer" title="ویرایش" (click)="add_Request(item,true)"></i>

                            <i class="fa fa-trash-o fa-lg pointer" title="حذف" (click)="remove_item(item,i)"></i>

                        </td>

                        <td> {{ item.iTaxiLon_Trip | faNum }} </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strMobile,searchTerm.value)  | faNum"> </td>

                        <td dir="ltr" style="background-color: #fda4af;"> {{ item.iDebit | number:'1.0-0' | faNum }} </td>

                        <td dir="ltr" style="background-color: #6ee7b7;"> {{ item.iCredit | number:'1.0-0' | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strDetail,searchTerm.value)  | faNum"> </td>

                    </tr>

                </tbody>

            </table>

        </div>

        <div class="col-12 bg-th-blue py-2">

            <span class="pe-2"> سرجمع بدهکاری : <b> {{ iDebit | number:'1.0-0' | faNum }} ریال  </b> </span>

            <span class="px-3"> سرجمع بستانکاری : <b> {{ iCredit | number:'1.0-0' | faNum }} ریال </b> </span>

        </div>

    </div>

</main>

<!-- افزودن بدهکاری/بستانکاری -->

<div class="modal fade" id="Request_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ editMode ? 'ویرایش' : 'افزودن' }} بدهکاری/بستانکاری </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Request" class="row gx-2 gy-2 p-2">

                    <!-- تاریخ -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label> تاریخ </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input formControlName="strDate" class="form-control text-end p-2" />
            
                        </ng-persian-datepicker>
            
                    </div>

                    <!-- بدهکاری -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> بدهکاری </label>
            
                        <input class="form-control p-2 text-center"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iDebit">
            
                    </div>

                    <!-- بستانکاری -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> بستانکاری </label>
            
                        <input class="form-control p-2 text-center" 

                            oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        
                            formControlName="iCredit">
            
                    </div>
                                    
                    <!-- توضیحات -->
            
                    <div class="position-relative col-12 p-2">
            
                        <label class="mb-2 text-muted"> توضیحات </label>
            
                        <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strDetail"></textarea>
            
                    </div>
            
            
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button [ngClass]="editMode ? 'btn-primary' : 'btn-success'" class="btn" (click)="submit_Request()">

                    &nbsp; &nbsp; {{ editMode ? 'ویرایش' : 'ثبت' }} &nbsp; &nbsp;

                </button>


                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>